import './sign-up-form.scss'
import { useState } from 'react';
import { Button } from '../button/button';
import {FormInput} from '../form-input/form-input';
import {createAuthUserWithEmailAndPassword, createUserDocumentFromAuth} from '../../utils/firebase/firebase.utils'
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
const defaultFormField={
    displayName:'',
    email:'',
    password:'',
    confirmPassword:''
}
export const SignUpForm =()=>{
    const [formFields, setFormField] =useState(defaultFormField);
    const {displayName,email,password,confirmPassword} = formFields;
    console.log(formFields);
    //-------------------------------------------------- 
    const resetFormFields=()=>{
        setFormField(defaultFormField);
    }
    //--------------------------------------
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if(password !== confirmPassword){
            alert("passwords do not match");
            return;
        }
        try{
            const {user} = await createAuthUserWithEmailAndPassword(email,password);
            console.log('response from firebase  user = ',user)
            await createUserDocumentFromAuth(user,displayName); // {displayName}
            resetFormFields();
            alert('MaBrooOK success to sign Up 😄');
        }catch(err){
            if(err.code === 'auth/email-already-in-use'){
                alert('Cannot create user, email already in use');
            }
            else if(err.code === 'auth/weak-password'){
                alert(' Password should be at least 6 characters (auth/weak-password).');
            }
            console.log("error on user creation : ", err);
        }
    }

    //---------------------------------------------------
    const handleChange = (event) =>{
        const {name,value} = event.target;
        setFormField({...formFields,[name]:value});
    }
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    return(
        <div className='sign-up-container'>
            <h2 id='account2'>Don't have an account?</h2>
            <span>Sign up with your email and password</span>
            <form className='signUpForm' onSubmit={handleSubmit}>
                
                <FormInput label="DisplayName" 
                type="text" required 
                onChange={handleChange} 
                name='displayName' value={displayName} />
               
                <FormInput label="Email" 
                type="email" required 
                onChange={handleChange} 
                name='email' value={email} />
               
                <FormInput label="Password" 
                type="password" required 
                onChange={handleChange} 
                name='password' value={password} />
                
                <FormInput label="Confirm password" 
                type="password" required 
                onChange={handleChange} 
                name='confirmPassword' value={confirmPassword} />

                <Button buttonType={'inverted'} type={'submit'}>Sign Up</Button>
            </form>
        </div>
    );
    //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
}

// export default SignUp;
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx